import GroupsEmptyState from '@web/groups/EmptyStates/GroupsEmptyState';

export default {
  ReactComponent: GroupsEmptyState,
};
